import { Pipe, PipeTransform } from '@angular/core';
import QRCode from 'qrcode';

@Pipe({
  name: 'qrcode'
})
export class QrcodeUrlPipe implements PipeTransform {

  async transform(value: string): Promise<string> {
    return await this.getQrCode(value);
  }

  // 生成二维码
  private async getQrCode(text: string) {
    return QRCode.toDataURL(text, {
      type: 'image/png',
      margin: 0,
      width: 400
    });
  }
}
